import React, { Component } from 'react';
import { loadReCaptcha } from 'react-recaptcha-google';
import { fetchPassword } from './../helpers/api/user';
import { isEmailValid } from './../helpers/validation';
import Password from './PasswordRemindComponent';

const REMIND_TYPE_EMAIL = 'email';

class PasswordRemindContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      valid: true,
      sent: false,
      error: null,
      isLoading: false
    };
  }

  componentDidMount() {
    loadReCaptcha();
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value, valid: true, error: null });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { username } = this.state;

    this.setState({ isLoading: true });

    if (this.isFormValid()) {
      fetchPassword(username, REMIND_TYPE_EMAIL)
        .then(() =>
          this.setState({ sent: true, valid: true, isLoading: false })
        )
        .catch(error => this.setState({ error, isLoading: false }));
    } else {
      this.setState({ valid: false, isLoading: false });
    }
  };

  isFormValid = () => isEmailValid(this.state.username);

  render() {
    const { username, valid, sent, error, isLoading } = this.state;
    // todo: loader not working with captcha; removed temporarily

    return (
      <Password
        valid={valid}
        username={username}
        sent={sent}
        error={error}
        loading={isLoading}
        sentText="Wysłano hasło na podany adres e-mail"
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default PasswordRemindContainer;
